const ExportIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 -960 960 960"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    color="inherit"
  >
    <path d="M280-160v-80h400v80H280Zm160-160v-327L336-544l-56-56 200-200 200 200-56 56-104-103v327h-80Z" />
  </svg>
);

export default ExportIcon;
